@if (vm$ | async; as vm) {
<div class="container main-container">
  <div class="meeting-info-header">
    <img
      src="/assets/images/confirm-tick.svg"
      alt="Success"
      class="confirm-icon"
    />
    <p class="header-text" i18n="@@RESCHEDULE.APPOINTMENT_RESCHEDULED">
      {{ 'RESCHEDULE.APPOINTMENT_RESCHEDULED' | translate }}
    </p>
    <p class="secondary-text-color" i18n="@@RESCHEDULE.SUCCESS_DESCRIPTION">
      {{ 'RESCHEDULE.SUCCESS_DESCRIPTION' | translate }}
    </p>
  </div>
  <!-- Details Section -->
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">person</mat-icon>
      <div class="header-title">{{ 'CANCEL_INFO.DETAILS' | translate }}</div>
    </div>
    <div class="component-body profile-backdrop">
      <p class="primary-text">{{ vm.displayTitle }}</p>
      @if (vm.hostNames) {
      <p class="secondary-text-color">with {{ vm.hostNames }}</p>
      }
    </div>
  </div>
  <!-- When Section -->
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">today</mat-icon>
      <div class="header-title">{{ 'CANCEL_INFO.WHEN' | translate }}</div>
    </div>
    <div class="component-body calendar-backdrop">
      <!-- Old time with strikethrough (only shown on fresh reschedule, not on page reload) -->
      @if (vm.showOldTime) {
      <div class="old-time">
        <p class="strikethrough">{{ vm.oldDateFormatted }}</p>
        <p class="strikethrough">
          {{
            vm.oldTimeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
          }}
          to
          {{
            vm.oldTimeSlot.end | date : 'h:mm a' : (timezoneOffset$ | async)
          }},
          {{ vm.oldTimezoneZone }}
        </p>
      </div>
      }
      <!-- New time -->
      @if (vm.newTimeSlot) {
      <div class="new-time-section">
        <p class="primary-text">{{ vm.newDateFormatted }}</p>
        <div class="flex-space-between">
          <span class="primary-text">
            {{
              vm.newTimeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
            }}
            to
            {{
              vm.newTimeSlot.end | date : 'h:mm a' : (timezoneOffset$ | async)
            }},
            {{ vm.newTimezoneZone }}
          </span>
          <span class="display-duration">{{ vm.newDurationFormatted }}</span>
        </div>
      </div>
      }
    </div>
  </div>
  <!-- Where Section -->
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">location_on</mat-icon>
      <div class="header-title">{{ 'CANCEL_INFO.WHERE' | translate }}</div>
    </div>
    @if (vm.isBatch && vm.isInPerson) {
      @for (meeting of vm.meetings; track meeting.meetingId) {
        @if (meeting.isInPerson && meeting.location) {
        <div class="component-body location-backdrop batch-meeting-link-box">
          <p class="batch-meeting-title">{{ meeting.eventTypeName }}</p>
          <p class="location-text">{{ meeting.location }}</p>
          <div class="anchor-tag" (click)="navigateToGoogleMaps(meeting.location)">
            <img src="/assets/images/direction.svg" alt="Direction" class="direction-icon" />
            {{ 'MEETING_INFO.GET_DIRECTIONS' | translate }}
          </div>
        </div>
        } @else {
        <div class="component-body location-backdrop batch-meeting-link-box">
          {{ meeting.eventTypeName }} - {{ 'CANCEL_INFO.ONLINE_APPOINTMENT' | translate }}
        </div>
        }
      }
    } @else if (vm.isBatch && !vm.isInPerson) {
      <div class="component-body location-backdrop">
        <p class="location-text">{{ 'CANCEL_INFO.ONLINE_APPOINTMENT' | translate }}</p>
      </div>
    } @else {
      @if (vm.showLocation) {
      <div class="component-body location-backdrop">
        <p class="location-text">{{ vm.location }}</p>
        <div class="anchor-tag" (click)="navigateToGoogleMaps(vm.location)">
          <img src="/assets/images/direction.svg" alt="Direction" class="direction-icon" />
          {{ 'MEETING_INFO.GET_DIRECTIONS' | translate }}
        </div>
      </div>
      } @else {
      <div class="component-body location-backdrop">
        <p class="location-text">{{ 'CANCEL_INFO.ONLINE_APPOINTMENT' | translate }}</p>
      </div>
      }
    }
  </div>
  <!-- Meeting Link Section -->
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">link</mat-icon>
      <div class="header-title">{{ 'MEETING_INFO.MEETING_LINK' | translate }}</div>
    </div>
    @if (vm.isBatch) {
      @for (meeting of vm.meetings; track meeting.meetingId) {
        @if (meeting.isVideo && meeting.hasMeetingLink) {
        <div class="component-body meeting-link-backdrop batch-meeting-link-box">
          <p class="batch-meeting-title">
            {{ meeting.eventTypeName }} - {{ meeting.meetingSourceText }} Meeting
          </p>
          <div class="flex-space-between">
            <button
              mat-button
              mat-flat-button
              color="primary"
              class="outlined-button"
              (click)="openLinkInNewTab(meeting.meetingSourceLink)"
            >
              <div class="button-content">
                <img
                  src="/assets/images/video.svg"
                  alt="video"
                  class="direction-icon"
                />
                Join with {{ meeting.meetingSourceText }}
              </div>
            </button>
            <div class="anchor-tag" (click)="navigateToHelpLink(meeting.meetingSource)">
              <img
                src="/assets/images/need-help-joining.svg"
                alt="help"
                class="direction-icon need-help-icon"
              />
              <div i18n="@@MEETING_INFO.NEED_HELP_JOINING">Need help joining?</div>
            </div>
          </div>
        </div>
        } @else if (meeting.isInPerson) {
        <div class="component-body secondary-text-color meeting-link-backdrop batch-meeting-link-box align-left">
          {{ meeting.eventTypeName }} - {{ 'MEETING_INFO.IN_PERSON_APPOINTMENT_SHORT' | translate }}
        </div>
        }
      }
    } @else {
      @if (vm.isVideo && vm.hasMeetingLink) {
      <div class="component-body meeting-link-backdrop">
        <p class="primary-text">
          {{ vm.title }} - {{ vm.meetingSourceText }} Meeting
        </p>
        <div class="flex-space-between">
          <button
            mat-button
            mat-flat-button
            color="primary"
            class="outlined-button"
            (click)="openLinkInNewTab(vm.meetingSourceLink)"
          >
            <div class="button-content">
              <img
                src="/assets/images/video.svg"
                alt="video"
                class="direction-icon"
              />
              Join with {{ vm.meetingSourceText }}
            </div>
          </button>
          <div class="anchor-tag" (click)="navigateToHelpLink(vm.meetingSource)">
            <img
              src="/assets/images/need-help-joining.svg"
              alt="help"
              class="direction-icon need-help-icon"
            />
            <div i18n="@@MEETING_INFO.NEED_HELP_JOINING">Need help joining?</div>
          </div>
        </div>
      </div>
      } @if (vm.isInPerson) {
      <div
        class="component-body secondary-text-color meeting-link-backdrop align-left"
      >
        {{ 'MEETING_INFO.IN_PERSON_APPOINTMENT' | translate }}
      </div>
      }
    }
  </div>
  <!-- Add to Calendar Section -->
  <div
    class="margin-top-20 flex-center-align component-body padding-30 add-to-calendar-section"
  >
    <div>{{ 'MEETING_INFO.ADD_TO_CALENDAR' | translate }}</div>
    @if (vm.hasCalendarLinks) {
    <div class="add-to-calendar-actions">
      @if (vm.googleCalendarLink) {
      <button
        mat-button
        mat-flat-button
        class="outlined-button"
        (click)="openLinkInNewTab(vm.googleCalendarLink)"
      >
        <div class="button-content">
          <img
            src="/assets/images/google.svg"
            alt="Google"
            class="direction-icon"
          />
          {{ 'MEETING_INFO.GOOGLE' | translate }}
        </div>
      </button>
      } @if (vm.outlookCalendarLink) {
      <button
        mat-button
        mat-flat-button
        class="outlined-button"
        (click)="openLinkInNewTab(vm.outlookCalendarLink)"
      >
        <div class="button-content">
          <img
            src="/assets/images/outlook-team.svg"
            alt="Outlook"
            class="direction-icon"
          />
          {{ 'MEETING_INFO.OUTLOOK' | translate }}
        </div>
      </button>
      }
    </div>
    } @if (!vm.hasCalendarLinks) {
    <div class="secondary-text-color text-center">
      {{ 'MEETING_INFO.CALENDAR_LINK_MESSAGED_SHORTLY' | translate }}
    </div>
    }
  </div>
  <!-- Need to make changes -->
  @if (vm.rescheduleLink || vm.cancelLink) {
  <div class="margin-top-20 flex-row-center">
    <div i18n="@@MEETING_INFO.NEED_TO_MAKE_CHANGES">{{ 'MEETING_INFO.NEED_TO_MAKE_CHANGES' | translate }}</div>
    <div class="links-row">
      @if (vm.rescheduleLink) {
      <div
        class="reschedule-anchor"
        (click)="openLinkInNewTab(vm.rescheduleLink)"
      >
        {{ 'BOOK.RESCHEDULE' | translate }}
      </div>
      } @if (vm.rescheduleLink && vm.cancelLink) {
      <span>{{ 'MEETING_INFO.OR' | translate }}</span>
      } @if (vm.cancelLink) {
      <div class="cancel-anchor" (click)="openLinkInNewTab(vm.cancelLink)">
        {{ 'CANCEL_INFO.CANCEL' | translate }}
      </div>
      }
    </div>
  </div>
  }
  <!-- Business Logo -->
  @if (vm.businessLogo) {
  <div class="margin-top-20 flex-center-align">
    <img [src]="vm.businessLogo" alt="Business Logo" class="business-logo" />
  </div>
  }
</div>
} @else {
<div class="loading-container">
  <div class="loading-spinner"></div>
</div>
}
